import React from 'react';
import logo from 'logo.svg';
import 'app/App.css';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { queryClient } from './api/queryClient';
import { ThemeProvider } from 'app/components/ThemeProvider/ThemeProvider';
import { StyledEngineProvider } from '@mui/material';
import MainPage from 'app/components/MainPage';
import Header from "app/components/Header/Header";

function App() {
  return (
    <ThemeProvider mode={'light'}>
      <StyledEngineProvider injectFirst>
        <QueryClientProvider client={queryClient}>
            <Header/>
          <MainPage />
        </QueryClientProvider>
      </StyledEngineProvider>
    </ThemeProvider>
  );
}

export default App;
